module.exports = __webpack_public_path__ + "static/img/banan.79e6b834.webp";